/** @jsxImportSource @emotion/react */
import { ClassNames, css } from "@emotion/react";
import { DialogTitle } from "@mui/material";
import { ReactNode } from "react";

import { StylableProps } from "../../types";
import { Typography } from "../typography";

interface ModalTitleProps extends StylableProps {
  children: ReactNode;
  fontSize?: string;
}

export function ModalTitle({ className, children, fontSize }: ModalTitleProps) {
  return (
    <ClassNames>
      {({ css: classNameCss, cx }) => (
        // `div` instead of the default `h2`: the title text is the Typography below
        <DialogTitle
          className={cx(
            // DialogTitle is an `h6` Typography, which would size an em-based
            // `fontSize` from the app's h6 font
            classNameCss`
              font: inherit;
              letter-spacing: inherit;
            `,
            className
          )}
          component="div"
        >
          <Typography
            css={() => {
              if (fontSize) {
                return css`
                  font-size: ${fontSize};
                `;
              }
            }}
            variant="h5"
            component="h1"
            color="textPrimary"
          >
            {children}
          </Typography>
        </DialogTitle>
      )}
    </ClassNames>
  );
}
